/**
 * ギャラリー表示時のリロード防止専用スクリプト
 * 問題: iPhoneでギャラリー表示中にピンチズームするとページがリロードされる
 * 解決: リサイズイベントとピンチズームを適切に制御
 */

(function() {
    'use strict';
    
    // ギャラリーが開いているかチェック
    let isGalleryOpen = false;
    let resizeTimer = null;
    
    // ギャラリーの状態を監視
    function checkGalleryState() {
        // クイックビューが開いているかチェック（これは除外する）
        const quickView = document.querySelector('.product-page--quick-view, .quick-view__container, .popup-quick-view');
        if (quickView && quickView.offsetParent !== null) {
            // クイックビューが開いている場合は何もしない
            if (isGalleryOpen) {
                isGalleryOpen = false;
                disableProtection();
            }
            return;
        }
        
        // モバイルギャラリーが開いているかチェック（モバイル専用）
        let galleryFound = false;
        
        // モバイルかどうかチェック
        const isMobile = window.innerWidth < 768;
        
        if (isMobile) {
            // モバイルギャラリーのセレクター
            const mobileGallerySelectors = [
                '.product-gallery__main.slick-initialized',
                '.product-gallery--mobile-carousel',
                '[data-product-gallery-main].slick-initialized'
            ];
            
            for (const selector of mobileGallerySelectors) {
                const element = document.querySelector(selector);
                if (element && element.offsetParent !== null) {
                    // ギャラリーアイコンが非表示かチェック
                    const galleryIcon = document.querySelector('.product-gallery__image-gallery-icon');
                    if (galleryIcon && galleryIcon.offsetParent === null) {
                        galleryFound = true;
                        break;
                    }
                }
            }
        }
        
        if (galleryFound !== isGalleryOpen) {
            isGalleryOpen = galleryFound;
            console.log('[Gallery Fix] Gallery is', isGalleryOpen ? 'OPEN' : 'CLOSED');
            
            if (isGalleryOpen) {
                enableProtection();
            } else {
                disableProtection();
            }
        }
    }
    
    // 保護機能を有効化
    function enableProtection() {
        // リサイズイベントをインターセプト
        window.addEventListener('resize', handleResize, true);
        
        // タッチイベントを監視（ピンチズーム検出用）
        document.addEventListener('touchstart', handleTouchStart, { passive: false });
        document.addEventListener('touchmove', handleTouchMove, { passive: false });
        document.addEventListener('touchend', handleTouchEnd, { passive: false });
        
        // iOSのジェスチャーイベントも制御
        document.addEventListener('gesturestart', handleGesture, { passive: false });
        document.addEventListener('gesturechange', handleGesture, { passive: false });
        document.addEventListener('gestureend', handleGesture, { passive: false });
    }
    
    // 保護機能を無効化
    function disableProtection() {
        window.removeEventListener('resize', handleResize, true);
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
        document.removeEventListener('gesturestart', handleGesture);
        document.removeEventListener('gesturechange', handleGesture);
        document.removeEventListener('gestureend', handleGesture);
    }
    
    // リサイズイベントを処理
    function handleResize(e) {
        if (!isGalleryOpen) return;
        
        // リサイズイベントによるリロードを防ぐ
        e.stopImmediatePropagation();
        e.preventDefault();
        
        // デバウンス処理
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            console.log('[Gallery Fix] Resize event blocked during gallery view');
        }, 100);
        
        return false;
    }
    
    // タッチイベントを処理
    let touchCount = 0;
    
    function handleTouchStart(e) {
        if (!isGalleryOpen) return;
        touchCount = e.touches.length;
    }
    
    function handleTouchMove(e) {
        if (!isGalleryOpen) return;
        
        // マルチタッチ（ピンチ）の場合
        if (e.touches.length > 1) {
            console.log('[Gallery Fix] Pinch gesture detected, preventing default');
            e.preventDefault();
        }
    }
    
    function handleTouchEnd(e) {
        if (!isGalleryOpen) return;
        touchCount = e.touches.length;
    }
    
    // ジェスチャーイベントを処理（iOS Safari）
    function handleGesture(e) {
        if (!isGalleryOpen) return;
        
        console.log('[Gallery Fix] Gesture blocked:', e.type);
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    
    // ページナビゲーションを監視
    window.addEventListener('beforeunload', function(e) {
        if (isGalleryOpen) {
            console.warn('[Gallery Fix] Page unload detected while gallery is open');
        }
    });
    
    // 初期化
    document.addEventListener('DOMContentLoaded', function() {
        console.log('[Gallery Fix] Initializing gallery protection');
        
        // 定期的にギャラリーの状態をチェック
        setInterval(checkGalleryState, 500);
        
        // MutationObserverでも監視
        const observer = new MutationObserver(checkGalleryState);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
        
        // ギャラリーアイコンのクリックを監視
        document.addEventListener('click', function(e) {
            const icon = e.target.closest('.product-gallery__image-gallery-icon, [data-js-product-gallery-icon]');
            if (icon) {
                console.log('[Gallery Fix] Gallery icon clicked');
                setTimeout(checkGalleryState, 100);
                setTimeout(checkGalleryState, 500);
            }
        }, true);
        
        // 初回チェック
        checkGalleryState();
    });
    
})();